export const formatPercentage = (value: number) => `${value > 0 ? '+' : ''}${value.toLocaleString('es-AR')}%`;
